import { all, fork, takeLatest } from 'typed-redux-saga';

import { GET_RECOMMENDATIONS_FROM_PRODUCT_HISTORY_SUCCESS } from '@/domains/productDiscovery/Recommendation/modules/ProductHistory/ProductHistory.actions';

import {
  GET_AUTO_COMPLETE_SUGGESTIONS,
  GET_EMPTY_SEARCH_SUGGESTIONS,
  UPDATE_EMPTY_SEARCH_SUGGESTIONS,
} from './HeaderLeonidas.searchBar.actions';
import {
  getEmptySearchSuggestions,
  updateSuggestionsHistorySaga,
} from './sagas/getEmptySearchSuggestions.saga';
import { getSuggestions } from './sagas/getSuggestions.saga';

function* watchInitAutoComplete() {
  yield all([
    takeLatest(GET_EMPTY_SEARCH_SUGGESTIONS, getEmptySearchSuggestions),
    takeLatest(GET_EMPTY_SEARCH_SUGGESTIONS, function* saga() {
      yield takeLatest(
        GET_RECOMMENDATIONS_FROM_PRODUCT_HISTORY_SUCCESS,
        getEmptySearchSuggestions,
      );
    }),
    takeLatest(UPDATE_EMPTY_SEARCH_SUGGESTIONS, updateSuggestionsHistorySaga),
    takeLatest(GET_AUTO_COMPLETE_SUGGESTIONS, getSuggestions),
  ]);
}

export function* headerSearchSaga() {
  yield all([fork(watchInitAutoComplete)]);
}
